import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import toastr from 'toastr';
import breakpoints from '../../../../shared/breakpoints';
import Callout from '../../../../shared/callout';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import ErrorBoundary from '../../../../shared/error-boundary';
import { unbookmark } from '../../../../services/wire/bookmark-service';

const MenuItem = ({
  href, children, itemClass, ...other
}) => (
  <li className="text-left">
    <a
      href={href}
      className={classNames(itemClass, { '--current': window.location.pathname === href })}
      {...other}
    >
      {children}
    </a>
  </li>
);

MenuItem.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node.isRequired,
  itemClass: PropTypes.string.isRequired,
};

MenuItem.defaultProps = {
  href: '#',
};

export default class BookmarkedWireCallout extends React.Component {
  static propTypes = {
    wire: PropTypes.shape({
      wire_id: PropTypes.number.isRequired,
    }).isRequired,
    rightAligned: PropTypes.bool,
  };

  static defaultProps = {
    rightAligned: true,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      presented: false,
    };

    this.deleteBookmark = this.deleteBookmark.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseup.BookmarkWireCallout', e => {
      if (breakpoints.getScreenSize() === 'small') return;

      const $target = $(e.target);
      const wireId = this.props.wire.wire_id.toString();

      if ($target.parents('.callout-inner-body').length) return;
      if ($target.hasClass('editors-manage-wire-callout') && $target.children('span').attr('data-wire-id') === wireId) return;
      if ($target.parents('.editors-manage-wire-callout').length && $target.attr('data-wire-id') === wireId) return;

      this.dismissCallout();
    });
  }

  toggleCallout() {
    this.setState(state => ({
      presented: !state.presented,
    }));
  }

  dismissCallout() {
    this.setState({
      presented: false,
    });
  }

  deleteBookmark() {
    toastr.info('Please wait, your saved wire is being removed...');

    unbookmark(this.props.wire.wire_id)
      .then(() => {
        this.dismissCallout();
        toastr.clear();
        toastr.success('Your saved wire has been removed');
        setTimeout(() => {
          window.location = '/profiles/me/saved_wires';
        }, 3000);
      })
      .catch(e => {
        defaultOnErrorHandler(e, 'Failed to remove saved wire');
      });
  }

  render() {
    return (
      <ErrorBoundary>
        <Callout
          indicatorPosition={this.props.rightAligned ? 'top-left' : 'top-right'}
          offsetY={60}
          offsetX={this.props.rightAligned ? 153 : 10}
          size="auto"
          calloutTrigger={<span className="icon-lw icon-lw-ellipsis" data-wire-id={this.props.wire.wire_id} />}
          show={this.state.presented}
          togglePresent={() => this.toggleCallout()}
          classModifier="editors-manage-wire-callout --wire"
        >
          <div className="callout-inner-body">
            <section>
              <h3 className="text-left">Manage Bookmarks</h3>
              <ul>
                <MenuItem itemClass="delete-bookmark" onClick={this.deleteBookmark}>Remove</MenuItem>
              </ul>
            </section>
          </div>
        </Callout>
      </ErrorBoundary>
    );
  }
}
